import StereoBaseActionHelper from '../-private/helpers/action-helper';

/**
  A helper to load a sound
  ```hbs
    <button {{on 'click' (play-sound @identifier}}>
      Play
    </button>
  ```
  @class {{pause-sound}}
  @type {Helper}
  */

/**
  @method compute
  @param {Any} identifier a url, an array of urls, a url object, a Sound, or a promise resolving to any of those
  @return {Function}
*/
export default class pauseSound extends StereoBaseActionHelper {
  performAction(sound) {
    if (sound) {
      sound.pause();
    } else {
      return false;
    }
  }
}
